import { render, staticRenderFns } from "./SalaryHistorySlide.vue?vue&type=template&id=2a7c885a&scoped=true"
import script from "./SalaryHistorySlide.vue?vue&type=script&lang=js"
export * from "./SalaryHistorySlide.vue?vue&type=script&lang=js"
import style0 from "./SalaryHistorySlide.vue?vue&type=style&index=0&id=2a7c885a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7c885a",
  null
  
)

export default component.exports